'use strict';

import * as angular from 'angular';
import { siteConfig } from './siteConfig';
import { exportarAgGridAExcel } from './utils/exportarAgGridAExcel';

// Exponer en window para controladores/directivas que lo usan por nombre global
window.exportarAgGridAExcel = exportarAgGridAExcel;

window.formatValueToDisplay = (value, fieldType = "") => {
    // Intenta convertir la cadena a número si es una cadena
    if (fieldType != "text" && typeof value === 'string' && !isNaN(value)) {
        value = Number(value); // Convierte la cadena a número
    }

    if (typeof value === 'number') {
        return value.toLocaleString(); // Formato con delimitador de miles
    } else if (typeof value === 'string') {
        return value; // Si es string, lo retorna tal cual
    } else if (value instanceof Date) {
        return value.toLocaleDateString(); // Si es fecha, lo formatea a una fecha
    }
    return value; // Si no es ninguno de los anteriores, lo retorna tal cual
}

window.maskValue = (value, field) => {
    function formatNumber(value, decimalPlaces = null, thousandSeparator = ",", decimalSeparator = ".") {
        if (isNaN(value) || value === null) return "";
        let [integerPart, decimalPart] = value.toString().split(".");
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
        if (decimalPlaces !== null) {
            decimalPart = Number(`0.${decimalPart || 0}`).toFixed(decimalPlaces).split(".")[1];
        }
        return decimalPart !== undefined ? `${formattedInteger}${decimalSeparator}${decimalPart}` : formattedInteger;
    }
    if(value==null || value==undefined) return "";
    if (["number", "formula"].includes(field.type) && !isNaN(value)) {
        return formatNumber(value,
            field.templateData?.forceDecimals ? (field.templateData.maxDecimalsCount || field.templateData?.formula?.decimals || 2) : null,
            field.templateData.thousandSeparator ? "," : ""
        );
    }
    if (["select", "multiple"].includes(field.type)) {
        const stripOptionLabel = (raw) => {
            if (raw == null || raw === '') return '';
            const s = String(raw);
            const idx = s.indexOf("|");
            return idx >= 0 ? s.substring(idx + 1) : s;
        };
        if (Array.isArray(value)) {
            return value.map(stripOptionLabel).join(',');
        }
        return stripOptionLabel(value);
    }
    return value; // Si no es ninguno de los anteriores, lo retorna tal cual
}



Date.prototype.getYYYYMMddHHmmss = function (useTimeSet = true) {
    let str = ""
    if (useTimeSet)
        str = new Date(this.getTime() - this.getTimezoneOffset() * 60000).toISOString().replace("T", " ").substr(0, 19)
    else
        str = new Date(this.getTime()).toISOString().replace("T", " ").substr(0, 19)
    return str;
}

Date.prototype.getYYYYMMdd = function (useTimeSet = true) {
    let str = ""
    str = this.getYYYYMMddHHmmss(useTimeSet).substr(0, 10)
    return str;
}

Date.prototype.addTimezoneOffset = function () {
    let date;
    date = new Date(this.getTime() + this.getTimezoneOffset() * 60000)
    return date;
}

Date.prototype.addDays = (days) => {
    if (!days) return this;
    let date = this ?? new Date();
    date.setDate(date.getDate() + days);
    return date;
};

Date.prototype.diffDaysOfDate = function(d2) {
    if (!(d2 instanceof Date)) d2 = new Date(d2); // Validamos/Convertimos
    if (isNaN(d2.getTime())) return 0;
    const msPorDia = 86400000;
    const diferencia = Math.abs(d2 - this) / msPorDia;
    return Math.round(diferencia * 100) / 100;
};


require('../templates');
require('../../field-sdk');
require('./login');
require('./waiting');
require('./auth');
require('./dashboard');
require('./dashboard-forms');
require('./dashboard-graphs');
// require('./dashboard-graph');
require('./dashboard-graph-view');
require('./dashboard-form');
require('./dashboard-form-teams');
require('./dashboard-teams');
require('./dashboard-team');
require('./dashboard-departments');
require('./dashboard-department');
require('./dashboard-department-admin');
require('./dashboard-department-admin-tagsync');
require('./dashboard-users');
require('./dashboard-builder');
require('./dashboard-graphBuilder');
require('./dashboard-data');
require('./dashboard-clients');
require('./dashboard-integrations');
require('./dashboard-integration');
require('./dashboard-sheets');
require('./dashboard-webhooks');
require('./dashboard-tasks');
require('./dashboard-task');
require('./dashboard-tasks-advanced');

require('./dashboard-tasks-templates');
require('./dashboard-validations');
require('./dashboard-statistics');
require('./dashboard-admin');
require('./dialogs');
require('./toast-directive');
require('./pivotTable-directive');
require('./gridGraph-directive');
require('./loading-directive');
require('./loading-icon-directive');
require('./chips-directive');
require('./chips-tags-directive');
require('./chips-users-tags-directive');
require('./user-unit-directive');
require('./toggle-directive');
require('./locales');
// the grid
require('ag-grid').initialiseAgGridWithAngular1(angular);
require('./chart.js')
require('./angular-chart.js')

require('./dashboard-wizard');
require("angular-bootstrap-colorpicker");
require("angular-translate");
require('angular-ui-calendar');

angular.module('Builder', [
    require('angular-ui-router'),
    require('angular-ui-bootstrap'),
    require('angular-animate'),
    require('angular-resource'),
    require('angular-ui-tree-field'),
    'ui.calendar',
    'chart.js',
    'templates',
    'login',"waiting",
    'dialogs',
    'directive.loading',
    'directive.loadingIcon',
    'directive.chips',
    'directive.chipsTags',
    'directive.chipsUsersTags',
    'directive.pivotTable',
    'directive.gridGraph',
    'directive.toggle',
    'directive.userUnit',
    'directive.toast',
    'dashboard',
    'graph.view',
    'lbServices',
    'auth',
    'agGrid',
    'ngLocale',
    require('ngmap'),
    require('ng-file-upload'),
    "colorpicker.module",
    'pascalprecht.translate'
])
    .run(['$rootScope', 'Authentication', 'Member', '$state', 'myDepartments', 'toast', '$translate', 'myTenant', '$window', function ($rootScope, Authentication, Member, $state, myDepartments, toast, $translate, myTenant, $window) {
        var bootSplash = document.getElementById('boot-splash');
        if (bootSplash && bootSplash.parentNode) {
            bootSplash.parentNode.removeChild(bootSplash);
        }

        $window.addEventListener('beforeunload', function () {
            localStorage.removeItem('validationFormHideNavBar');
        });

        var showLoadingToast = function (uid) {
            toast.loading($translate.instant('DASHBOARD.LOADING'), uid);
        };

        $rootScope.$on('$stateChangeStart', function (event, next, params, fromState, fromParams) {
            let favicon = document.querySelector("link[rel='icon']");
            if (!favicon) {
                favicon = document.createElement("link");
                favicon.rel = "icon";
                document.head.appendChild(favicon);
            }
            favicon.href = siteConfig?.productFavIcon || "/favicon.ico";

            //user is not logged in and is not trying to go to login screen
            var date = new Date();
            next.uid = date.getTime();
            if (!Member.isAuthenticated() && next.name !== 'login') {
                event.preventDefault();
                return $state.go('login');
            }
            //user is logged in and going to login screen → session bootstrap with progress UI
            if (next.name === 'login' && Member.isAuthenticated()) {
                event.preventDefault();
                return $state.go('waiting');
            }
            myTenant.load(true).then(function (tenant) {
                window.document.title = tenant?.name?.concat(" - ", siteConfig.productName || "Field", " by Voolks");
            });
            if (Authentication.isAuthorized("viewer") && siteConfig.viewerToWebapp != undefined) {
                console.log("")
                Authentication.resolveUser().then(function (user) {
                    const fromBuilder =
                    {
                        id: window.localStorage.$LoopBack$accessTokenId,
                        user: user,
                    }
                    const fromBuilderB64 = btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(fromBuilder))));
                    window.location.href = siteConfig.webapp[siteConfig.viewerToWebapp].url.concat("/fromBuilder#", fromBuilderB64);
                    $state.go('waiting');
                });

                return null;
            }


            //if no role is needed for route
            if (!next.data) {
                if (next.name !== fromState.name) {
                    showLoadingToast(next.uid);
                }
                return;
            }

            if (next.name === 'dashboard.departments.department' && !params.departmentId) {
                event.preventDefault();
                if (Authentication.isAuthorized('supervisor')) {
                    // console.log('validations 1')
                    return $state.go('dashboard.validations');
                }
                var departments = myDepartments.get();
                // console.log('llamado 1 myDepartments.get()')
                if (!departments) {
                    //return myDepartments.load(Authentication.isAuthorized("viewer"))
                    // console.log('llamado 1 Authentication.loadDepartments()')
                    return Authentication.loadDepartments()
                        .then(function (departments) {
                            if (departments && departments.length > 0) {
                                let deptId = localStorage.getItem('lastDepartment');
                                let departmentExists = departments.find(dept => dept.id == deptId);
                                let targetDeptId = departmentExists ? deptId : departments[0].id;
                                return $state.go('dashboard.departments.department', {
                                    departmentId: targetDeptId
                                });
                            } else {
                                Authentication.logOut()
                                    .then(function () {
                                        $state.go('login');
                                    })
                                    .catch(function () {
                                        $state.go('login');
                                    })
                            }
                        })
                        .catch(function () {

                        });
                }
                let deptId = localStorage.getItem('lastDepartment');
                let departmentExists = departments.find(dept => dept.id == deptId);
                let targetDeptId = departmentExists ? deptId : departments[0].id;
                return $state.go('dashboard.departments.department', {
                    departmentId: targetDeptId
                });
            }

            var authorizedRoles = next.data.authorizedRoles;
            if (!authorizedRoles) {
                if (next.name !== fromState.name) {
                    showLoadingToast(next.uid);
                }
                return;
            }
            //if user has no permission for this route...
            if (Member.isAuthenticated() && !Authentication.isAuthorized(authorizedRoles)) {
                console.log('No autorizado')
                console.log($translate.instant('DASHBOARD.NO_AUTHORIZED'));
                toast.error($translate.instant('DASHBOARD.NO_AUTHORIZED'));
                event.preventDefault();
                return;
            }

            if (next.name !== fromState.name) {
                showLoadingToast(next.uid);
            }

            if (next.name === fromState.name && params.departmentId !== fromParams.departmentId) {
                showLoadingToast(next.uid);
            }


        });
        $rootScope.$on('$stateChangeSuccess', function (event, next) {
            toast.closeLoaders(next.uid);
        });
        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            console.log(error);
        });
    }])
    .config(['$stateProvider', '$urlRouterProvider', '$locationProvider', '$httpProvider', '$compileProvider', 'LoopBackResourceProvider',
        function ($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, $compileProvider, LoopBackResourceProvider) {

            if (process.env.NODE_ENV !== 'development') {
                $compileProvider.debugInfoEnabled(false);
            }
            $httpProvider.defaults.headers.common['X-Brotli-Enabled'] = 'true';

            LoopBackResourceProvider.setUrlBase(require('./server').server);
            console.log(LoopBackResourceProvider.getUrlBase());

            $urlRouterProvider.otherwise(function ($injector) {
                var $state = $injector.get('$state');
                $state.go('login');
            });

            $httpProvider.interceptors.push(require('./graphHttpCancel').interceptor);

            $httpProvider.interceptors.push(['$q', '$injector', 'LoopBackAuth', 'toast', '$translate',
                function ($q, $injector, LoopBackAuth, toast, $translate) {
                    return {
                        responseError: function (rejection) {
                            var $state = $injector.get('$state');
                            var Authentication = $injector.get('Authentication');
                            var $rootScope = $injector.get('$rootScope');
                            //we only do this is i its not trying to login
                            if (rejection.status == 401 && rejection.data.error.code !== 'LOGIN_FAILED') {
                                if ($rootScope.isLoggingOut) {
                                    return $q.reject(rejection);
                                }

                                if (Authentication.isAuthorized('supervisor')) {
                                    console.log('No autorizado')
                                    toast.error($translate.instant('DASHBOARD.NO_AUTHORIZED'));

                                } else {
                                    Authentication.logOut()
                                        .then(function () {
                                            $state.go('login');
                                        })
                                        .catch(function () {
                                            $state.go('login');
                                        });
                                }

                            }
                            return $q.reject(rejection);
                        }
                    };
                }
            ]);

            $stateProvider
                .state('app', {
                    url: '/app',
                    template: '<div ui-view class="all-height"></div>',
                    abstract: true,
                    resolve: {
                        user: ['Authentication', function (Authentication) {
                            return Authentication.resolveUser();
                        }]
                    },
                    data: {
                        authorizedRoles: ['admin', 'mobileUser']
                    }
                });

            // use the HTML5 History API
            // $locationProvider.html5Mode(true);
        }
    ])
    .constant('$serverData', require('./server'))
    .constant('siteConfig', siteConfig)
    .factory('myDepartments', ['Department', 'Form', require('./myDepartments')])
    .factory('myTenant', ['Tenant', require('./myTenant')])
    .factory('graphHttpCancel', require('./graphHttpCancel'))
    .factory('graphDataFactory', ['$rootScope', '$stateParams', 'Department', 'Form', 'Graph', '$state', 'Integration', 'myDepartments', 'graphHttpCancel', require('./graphDataFactory')])
    .config(['$translateProvider', '$provide', function ($translateProvider, $provide) {

        let i18n_en = require("./locales/i18n_en.json");
        let i18n_es = require("./locales/i18n_es.json");

        $translateProvider.translations('en', i18n_en);

        $translateProvider.translations('es', i18n_es);

        $translateProvider.registerAvailableLanguageKeys(['en', 'es'], {
            'en_*': 'en',
            'es_*': 'es',
            '*': 'en'
        })

            .determinePreferredLanguage()

            .fallbackLanguage('es');
        if ($translateProvider.preferredLanguage() == "en") {
            let miFn = require('./locales/en-iso');
            miFn($provide);
        }

    }])
    .config(['$sceDelegateProvider', function ($sceDelegateProvider) {
        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading from our assets domain.  Notice the difference between * and **.
            'https://field-test.voolks.com/**',
            'https://field.voolks.com/**',
            'https://cgc.voolks.com/**',
            'https://pampaenergia.voolks.com/**',
            'https://graphs.voolks.com/**',
            'https://pampa.voolks.com/**',
            'https://pampageneracion.voolks.com/**',
        ]);
    }]);
;